var map = {
	"./symbol_0.png": "cdc4",
	"./symbol_1.png": "a1960",
	"./symbol_2.png": "160e",
	"./symbol_3.png": "a407",
	"./symbol_4.png": "2f5d",
	"./symbol_5.png": "c6bd",
	"./symbol_6.png": "ba88",
	"./symbol_7.png": "161a",
	"./symbol_8.png": "49be"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4202";